import { createEffect, createSignal, For, Show, type JSX, type Component } from "solid-js";

export interface SubTab {
  id: string;
  label: string;
  render: () => JSX.Element;
}

export interface PanelStatus {
  text: string;
  level?: "info" | "warn" | "danger";
}

export interface PanelLayoutProps {
  title: string;
  subtabs?: SubTab[];
  toolbar?: JSX.Element;
  status?: PanelStatus;
  children?: JSX.Element;
}

export const PanelLayout: Component<PanelLayoutProps> = (props) => {
  const [activeSub, setActiveSub] = createSignal("");

  createEffect(() => {
    const subtabs = props.subtabs;
    if (!subtabs?.length) {
      if (activeSub()) setActiveSub("");
      return;
    }
    if (!subtabs.some((st) => st.id === activeSub())) setActiveSub(subtabs[0].id);
  });

  return (
    <section class="panel-section panel-section--full">
      <div class="panel-section-header">
        <span class="eyebrow">{props.title}</span>
        <Show when={props.status}>
          {(s) => (
            <span class="ad-status" data-level={s().level || "info"}>
              {s().text}
            </span>
          )}
        </Show>
      </div>

      <Show when={props.subtabs && props.subtabs.length > 0}>
        <div class="panel-toolbar" role="tablist">
          <For each={props.subtabs}>
            {(st) => (
              <button
                type="button"
                class="panel-subtab"
                aria-selected={activeSub() === st.id}
                role="tab"
                onClick={() => setActiveSub(st.id)}
              >
                {st.label}
              </button>
            )}
          </For>
        </div>
      </Show>

      <Show when={props.toolbar}>
        <div class="panel-toolbar panel-toolbar--filter">{props.toolbar}</div>
      </Show>

      <div class="panel-data-wrap">
        <Show when={props.subtabs && props.subtabs.length > 0} fallback={props.children}>
          <For each={props.subtabs}>{(st) => <Show when={activeSub() === st.id}>{st.render()}</Show>}</For>
        </Show>
      </div>
    </section>
  );
};
